<template>
  <div class="contact-edit">
    <modal
      title=""
      class="edit-contact-modal"
      :open="isOpen"
      @save="save()"
      @cancel="cancel()"
    >
      <field
        v-model="workingContact.email"
        type="text"
        class="field"
        name="email"
        :label="$t('ui.contact.caption.email')"
        :autofocus="true"
      />
      <div class="flex">
        <field
          v-model="workingContact.firstname"
          type="text"
          class="field"
          name="firstname"
          :label="$t('ui.contact.caption.firstname')"
        />
        <field
          v-model="workingContact.lastname"
          type="text"
          class="field"
          name="lastname"
          :label="$t('ui.contact.caption.lastname')"
        />
      </div>
      <field
        v-model="workingContact.business_card_job_title"
        type="text"
        class="field"
        name="business_card_job_title"
        :label="$t('ui.contact.caption.business_card_job_title')"
      />
      <field
        v-model="workingContact.company_department"
        type="text"
        class="field"
        name="company_department"
        :label="$t('ui.contact.caption.company_department')"
      />
      <field
        v-model="workingContact.phone_private"
        type="text"
        class="field"
        name="phone_private"
        :label="$t('ui.contact.caption.phone_private')"
      />
      <div class="flex">
        <field
          v-model="workingContact.phone_company"
          type="text"
          class="field"
          name="phone"
          :label="$t('ui.contact.caption.phone_company')"
        />
        <field
          v-model="workingContact.phone_mobile"
          type="text"
          class="field"
          name="mobile"
          :label="$t('ui.contact.caption.phone_mobile')"
        />
      </div>
      <div class="flex">
        <field
          name="language"
          :label="$t('ui.contact.caption.language')"
          type="radio"
          :collection="[
            { value: 'en', name: 'English' },
            { value: 'de', name: 'German' }
          ]"
          v-model="workingContact.language"
        />
        <field
          name="gender"
          :label="$t('ui.contact.caption.gender')"
          type="radio"
          :collection="[
            { value: 'male', name: 'male' },
            { value: 'female', name: 'female' }
          ]"
          v-model="workingContact.gender"
        />
      </div>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/helpers/Layout/NewModal.vue"
import Field from "@/components/helpers/DataInput/Field"

export default {
  components: { Field, Modal },
  props: {
    contact: {
      type: Object,
      default: () => { return {} }
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      workingContact: {},
      workingCompany: {},
    };
  },
  beforeMount() {
    this.init()
  },
  watch: {
    isOpen: function() {
      return this.init()
    },
  },
  methods: {
    init() {
      this.workingContact = _.cloneDeep(this.contact)
      this.workingCompany = {}
      this.workingCompany = _.cloneDeep(this.workingContact.company)
    },
    save() {
      if (this.workingContact.company) {
        this.workingContact.company = {}
      }
      this.workingContact.company = this.workingCompany
      this.$emit('save', this.workingContact)
    },
    cancel() {
      this.$emit('cancel')
    }
  }
};
</script>

<style lang="sass">
@media (max-width: 575px)
  .edit-contact-modal
    max-height: 500px !important
    .modal-wrapper
      min-width: 100%
      width: 320px
    .modal-component
      padding: 1em 0 !important
      text-align: center !important

.contact-edit
  .modal-component
    max-height: 600px
  .field-radio
    width: 50%
</style>




// WEBPACK FOOTER //
// ContactEdit.vue?1c48c5db